export default __webpack_public_path__ + "static/nodegraph-5404c6e9a496a6f0e5f56f97eadd3768.png";